import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))
const Create = lazy(() => import('./components/Create'))
const Update = lazy(() => import('./components/Update'))

const JobCategoryModule: RouteObject = {
    path: 'job-categories',
    children: [
        {
            path: '',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: <Create />,
                },
                {
                    path: ':jobCategoryID',
                    children: [
                        {
                            path: '',
                            element: <Update />,
                        },
                    ],
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default JobCategoryModule
